import apiClient from '../components/apiClient';
import QuantityPricing from '../models/QuantityPricing';

export class StyleQuantityPricingService {
    static getQuantityPricing(styleCode: string) : Promise<QuantityPricing[]> {
        return apiClient.get<QuantityPricing[]>(`/StyleQuantityPricing/GetQuantityPricing/${styleCode}`).then(res => {
            return res.data});
    }
}